import FlatasticConfig from '../../scripts/config'
import ApiService from '../../scripts/modules/api'
import CollectionService from '../../scripts/modules/collection'
import ShoutService from './svc_shout'

export default angular.module('flatastic.shouts.service.notifications', [
  ApiService,
  CollectionService,
  ShoutService,
  FlatasticConfig,
])

.run([
    'Notifications', '$rootScope', '$timeout', 'User', 'FlatasticEvents',
    function(Notifications, $rootScope, $timeout, User, FlatasticEvents) {
  if (User.isLoggedIn() && User.properties.groupId == 2) {
    Notifications.getFromServer();
  }
  $rootScope.$on('Shout:deleted', function(event, shoutId) {
    $timeout(function() {
      Notifications.delete(shoutId);
      Notifications.updateShoutsWithDividers();
    });
  });
  $rootScope.$on(FlatasticEvents.user.didEnterWg, function() {
    Notifications.getFromServer();
  });
  $rootScope.$on(FlatasticEvents.user.didLogout, function() {
    Notifications.clear();
  });
}])

.factory('Notifications',
    ['Api', 'YepptCollection', 'Shout', 'LocalStorageKeys',
    function (Api, YepptCollection, Shout, LocalStorageKeys) {

  var activities = new YepptCollection('id', null, LocalStorageKeys.notifications.activities);

  var myStatus        = '';
  var limitGet        = 15;
  var moreCanBeLoaded = false;

  var getFromServer = function(limit) {
    myStatus = 'loading';
    var params = {
      limit: limit || limitGet,
      type: 'noShout',
    };
    return Api.get('/shouts', { params: params })
      .then(function({ data }) {
        var temp = [];
        data.forEach(function(shout) {
          temp.push(new Shout(shout));
        });
        activities.remove();
        activities.push(temp);
        updateShoutsWithDividers();
        moreCanBeLoaded = (data.length >= limitGet);
      })
      .finally(function() {
        myStatus = '';
      });
  };

  var loadMore = function(obj) {
    obj = obj || {};
    var length = activities.filter(function(item) {
      return item.shoutType !== 'divider';
    }).length;
    var params = {
      limit: obj.limit  || limitGet,
      offset: obj.offset || length,
      type: 'noShout',
    };
    return Api.get('/shouts', { params: params })
      .then(function({ data }) {
        var temp = [];
        data.forEach(function(shout) {
          temp.push(new Shout(shout));
        });
        activities.push(temp);
        moreCanBeLoaded = (data.length >= limitGet);
        updateShoutsWithDividers();
      });
  };

  var clear = function() {
    activities.remove();
  };

  var updateShoutsWithDividers = function() {

    var i;
    var activity;
    var currentDate;
    var lastDate;
    var divider;

    // Remove all dividers
    activities.removeWhere({ shoutType: 'divider' });

    // Add dividers
    for (i = 0; i < activities.length(); i++) {
      activity = activities.get()[i];
      currentDate = activity.insertDate.toDateString();
      if (currentDate !== lastDate) {
        lastDate = currentDate;
        divider = new Shout({
          shoutType: 'divider',
          insertDate: activity.insertDate,
        });
        activities.insert(i, divider);
        i++;
      }
    }
  };

  return {
    length: function() {
      return activities.length();
    },
    get: function(id) {
      return activities.get(id);
    },
    push: function(shoutObj, unshift) {
      return activities.push(shoutObj, unshift);
    },
    delete: function(id) {
      return activities.remove(id);
    },
    getFromServer,
    status: function() {
      return myStatus
    },
    loadMore,
    moreCanBeLoaded: function() {
      return moreCanBeLoaded;
    },
    updateShoutsWithDividers,
    clear,
  };

}])

.name;
